export const ASSIGN_TYPES = [
	{
		label: 'Por Asignar',
		key: 1,
	},
	{
		label: 'Asignados',
		key: 0,
	},
];

export default {};



// WEBPACK FOOTER //
// ./src/components/configuration/report-template/constant.js